import i18next from 'i18next';
import { JOB_STATUS, STATUS_GROUPS, normalizeStatus } from '../constants/jobStatus';
import { ACTIVITY_LABELS, activityLabelOf } from '../constants/labels';

// Route stop activities (RouteActivity enum in the API). Visible words come
// from labels.js so they are spelled the same everywhere.
export const ROUTE_ACTIVITIES = ['PICKUP', 'ON_SITE', 'DELIVERY'].map(value => ({ value, label: ACTIVITY_LABELS[value] }));

export const activityLabel = (value) => activityLabelOf(value);

const PICKUP_STAGE = [JOB_STATUS.NEW, JOB_STATUS.CONFIRMED, JOB_STATUS.SCHEDULED, JOB_STATUS.ARRIVED];
const DELIVERY_STAGE = [JOB_STATUS.FINISHING, JOB_STATUS.READY, JOB_STATUS.COMPLETED];

/** What a driver would do at this job today, from its stage and pickup type. */
export const suggestActivity = (job) => {
    const s = normalizeStatus(job.status);
    if (DELIVERY_STAGE.includes(s)) return 'DELIVERY';
    if (PICKUP_STAGE.includes(s)) return job.pickupType === 'CUSTOMER_DELIVERS' ? 'ON_SITE' : 'PICKUP';
    return 'ON_SITE';
};

/** The time the customer expects the driver for this activity. */
export const activityTime = (job, activity) => {
    if (!job) return null;
    if (activity === 'DELIVERY') return job.dispatchTime || job.completionTime || null;
    if (activity === 'PICKUP') return job.pickupTime || null;
    return job.pickupTime || job.deliveredByCustomerTime || job.dispatchTime || null;
};

// Jobs page "Activity" filter: which jobs need a driver for a pickup or a
// delivery right now.
export const JOB_ACTIVITY_FILTERS = [
    { value: '', get label() { return i18next.t('jobs.anyActivity', 'Any activity'); } },
    { value: 'pickup', get label() { return i18next.t('home.pickups', 'Pickups'); } },
    { value: 'delivery', get label() { return i18next.t('home.deliveries', 'Deliveries'); } },
];

export const matchesActivityFilter = (job, filter) => {
    if (!filter) return true;
    const raw = job.status;
    if (filter === 'pickup') {
        return job.pickupType === 'PICKUP_FROM_HOME' &&
            [...STATUS_GROUPS.NEW, ...STATUS_GROUPS.CONFIRMED, ...STATUS_GROUPS.SCHEDULED, ...STATUS_GROUPS.ARRIVED].includes(raw);
    }
    if (filter === 'delivery') {
        return [...STATUS_GROUPS.FINISHING, ...STATUS_GROUPS.READY].includes(raw);
    }
    return true;
};

// Users who can be handed a route: drivers and technicians. `roles` is the
// comma-joined string the users-as-options endpoint returns ("Driver, Cleaner").
export const canBeRouteAssignee = (user) => /\b(driver|cleaner)\b/i.test(String(user?.roles || ''));
